import { Page, Text, View } from '@react-pdf/renderer';
import type { ReactNode } from 'react';

import { palette, styles } from './styles';

interface PageShellProps {
  brandName: string;
  generatedAt: string;
  children: ReactNode;
}

export default function PageShell({
  brandName,
  generatedAt,
  children,
}: PageShellProps) {
  return (
    <Page size="A4" style={styles.page} wrap>
      <View style={styles.pageHeader} fixed>
        <Text style={styles.pageHeaderTitle}>BRAND ANALYSIS REPORT</Text>
        <Text style={styles.pageHeaderBrand}>{brandName}</Text>
      </View>

      {children}

      <View style={styles.pageFooter} fixed>
        <Text>Generated on {generatedAt}</Text>
        <Text
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
        />
        <Text style={{ color: palette.primary }}>Yoast AI Brand Insights</Text>
      </View>
    </Page>
  );
}
